module.exports = __webpack_public_path__ + "static/media/greentick.fb8585e6.svg";